import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {AddOutlined, DeleteOutlined, EditOutlined} from '@material-ui/icons';
import ContainedButton from '../../../../shared/buttons/ContainedButton.tsx';
import TabelaProcesso from '../../../components/processo/TabelaProcesso.jsx';
import {ouTraco} from '../../../components/inscricao/documentoInscricao.js';
import {salvarItemNaLista} from '../../../components/processo/processoSelecao.js';
import DialogVagaProcesso from '../../../dialogs/processo/DialogVagaProcesso.jsx';

/* Subaba "Cursos" da aba Inscrição: cursos permitidos (campus, curso e turno). */
export default function TabInscricaoCursos(props) {
    const {errors, vagas = [], campi = [], cursos = [], turnos = [], onAlterarLista, onRemover} = props;
    // Índice da vaga em edição: -1 para adicionar, null com o diálogo fechado.
    const [indiceVaga, setIndiceVaga] = useState(null);

    return (
        <>
            <Grid container spacing={3}>
                <TabelaProcesso
                    nome='vagas'
                    errors={errors}
                    linhas={vagas}
                    semRegistros='Nenhum curso registrado.'
                    botao={<ContainedButton startIcon={<AddOutlined/>} onClick={() => setIndiceVaga(-1)}>Adicionar</ContainedButton>}
                    colunas={[
                        {label: 'Curso', field: 'curso.descricao', valueGetter: (valor, row) => ouTraco(row.curso?.descricao)},
                        {label: 'Código', field: 'curso.codigo', valueGetter: (valor, row) => ouTraco(row.curso?.codigo)},
                        {label: 'Turno', field: 'turno.descricao', valueGetter: (valor, row) => (row.turno ? ouTraco(row.turno.descricao) : 'EAD')},
                        {label: 'Campus', field: 'campus.nome', valueGetter: (valor, row) => ouTraco(row.campus?.nome)}
                    ]}
                    acoes={(row, posicao) => [
                        {titulo: 'Editar', icone: <EditOutlined/>, onClick: () => setIndiceVaga(posicao)},
                        {
                            titulo: 'Excluir',
                            icone: <DeleteOutlined/>,
                            onClick: () => onRemover('vagas', vagas, posicao, 'Tem certeza que deseja remover esse curso?')
                        }
                    ]}/>
            </Grid>
            <DialogVagaProcesso
                open={indiceVaga !== null}
                onClose={() => setIndiceVaga(null)}
                vaga={indiceVaga !== null && indiceVaga > -1 ? vagas[indiceVaga] : null}
                indice={indiceVaga ?? -1}
                vagas={vagas}
                campi={campi}
                cursos={cursos}
                turnos={turnos}
                onSalvar={vaga => onAlterarLista('vagas', salvarItemNaLista(vagas, vaga, indiceVaga ?? -1))}/>
        </>
    );
}

TabInscricaoCursos.propTypes = {
    errors: PropTypes.object.isRequired,
    vagas: PropTypes.array,
    campi: PropTypes.array,
    /* Cursos do apoio para o programa e os processos vestibulares atuais. */
    cursos: PropTypes.array,
    turnos: PropTypes.array,
    onAlterarLista: PropTypes.func.isRequired,
    onRemover: PropTypes.func.isRequired
};
